'use strict';

module.exports = require('./dist/openchemlib-minimal');



// WEBPACK FOOTER //
// ./node_modules/openchemlib/minimal.js